// This implementation is heavily inspired by react-aria's implementation
import React from 'react'

const defaultIdContext = {
  current: 1
}

const IdContext = React.createContext(defaultIdContext)

export const IdProvider = React.memo(({ children }) => {
  return React.createElement(
    IdContext.Provider,
    { value: { current: 1 } },
    children
  )
})

const genId = context => context.current++

export function useId(idProp, prefix) {
  const context = React.useContext(IdContext)
  const [id, setId] = React.useState(context.current)

  React.useEffect(() => {
    setId(genId(context))
  }, [context])

  return React.useMemo(
    () => idProp || [prefix, id].filter(Boolean).join('-'),
    [idProp, prefix, id]
  )
}

export function useIds(idProp, ...prefixes) {
  const id = useId(idProp)
  return React.useMemo(() => {
    return prefixes.map(prefix => `${prefix}-${id}`)
  }, [id, prefixes])
}
